import { useCurrentUser } from './useAuth';

/**
 * Resolves the enterprise UUID the app should scope to for the current user.
 *
 * The explicit active-enterprise context wins (FE-E2): when an internal super
 * admin switches company via the dashboard switcher, `active_enterprise_uuid`
 * is set server-side and every page must re-scope to that company ("view as the
 * Company Admin"). Only when no active enterprise is set do we fall back to the
 * user's first role's enterprise (the normal single-company admin case).
 *
 * Returns undefined when neither is present (e.g. a platform superuser who has
 * not yet picked a company and holds no enterprise role).
 */
export function useEnterpriseUuid() {
  const { data: user, isLoading, error } = useCurrentUser();
  const enterpriseUuid =
    user?.active_enterprise_uuid ?? user?.roles?.[0]?.enterprise_uuid ?? undefined;
  return { enterpriseUuid, isLoading, error };
}
